<template>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="tableItems"
          :loading="loading"
          :loading-text="$t('keywords.loading')"
          :items-per-page.sync="_itemsPerPage_"
          :must-sort="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="elevation-1"
        >
          <template #top>
            <v-toolbar flat color="white">
              <v-toolbar-title v-text="`${$t('monitoring.logs_of')} ${$route.query.integrationID}`" />
              <v-spacer />
              <GoBackButton style="margin: 0 1vh" />
              <RefreshButton @click="$emit('refresh')" />
            </v-toolbar>
          </template>
          <template #item.monitoringID="{ item }">
            <v-btn v-if="item.monitoringID" v-text="item.monitoringID" @click="showLog(item)" />
          </template>
          <template #item.status="{ item }">
            <v-icon
              v-html="Utils.getStatusIcon(item.status)"
              :color="Utils.getStatusColor(item.status)"
            />
          </template>
          <template #no-data v-text="$t('warnings.no_data_found')" />
        </v-data-table>
      </v-col>
    </v-row>
</template>
<script>
import Utils from '../../utils'
import RefreshButton from '../RefreshButton.vue'
import GoBackButton from '../GoBackButton.vue'

export default {
  name: 'DataTable',
  props: {
    itemsPerPage: Number,
    loading: Boolean,
    items: Array
  },
  computed: {
    tableItems () {
      return Utils.fillPagination(this.items, this.itemsPerPage)
        .map(obj => Utils.formatObjectDate(obj))
        .map(obj => Utils.formatObjectExecutionTime(obj))
    },
    _itemsPerPage_: {
      get () { return this.itemsPerPage },
      set (v) { this.$emit('change', v) }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'monitoringID',
          sortable: true,
          align: 'start'
        },
        {
          text: this.$t('monitoring.execution_time'),
          value: 'executionTime',
          sortable: true,
          align: 'center'
        },
        // {
        //   text: 'Total Bytes',
        //   value: 'totalBytes',
        //   sortable: true,
        //   align: 'right'
        // },
        {
          text: this.$t('monitoring.status'),
          value: 'status',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('monitoring.date'),
          value: 'date',
          sortable: false,
          align: 'center'
        }
      ]
    }
  },
  data: () => ({
    Utils,
    sortBy: 'monitoringID',
    sortDesc: true
  }),
  methods: {
    showLog ({ date, monitoringID }) {
      const { processType, integrationID } = this.$route.query
      const query = {
        processType,
        integrationID,
        date: Utils.rawDate(date),
        monitoringID
      }
      const someFieldInvalid = Object.values(query).some(v => !v)
      if (someFieldInvalid) { return }
      this.$router.push({ path: 'show-log', query })
    }
  },
  components: { RefreshButton, GoBackButton }
}
</script>
